import { Card, CardContent } from "@babackapp/ui/components/card";
import { FormField } from "@babackapp/ui/components/form";
import { useViewerHasAtLeastAdminRights } from "@/lib/rights/use-viewer-has-right";
import FormInput from "@babackapp/react-hook-forms-components/form-input";
import FormInputRow from "@babackapp/react-hook-forms-components/form-input-row";
import { SettingsFormSectionHeader } from "@babackapp/react-hook-forms-components/form-page";
import { useFormContext } from "react-hook-form";
import { ShopSettingsFormValues } from "./types";
import useTranslation from "@babackapp/translations/use-translation";

export default function ShopSettingsContactForm() {
  const t = useTranslation();
  const { control } = useFormContext<ShopSettingsFormValues>();

  const isAdmin = useViewerHasAtLeastAdminRights();
  const disabledBecauseNotAdmin = isAdmin
    ? false
    : t("settings.shop.errors.notAdmin");

  return (
    <>
      <SettingsFormSectionHeader
        title={t("settings.shop.sections.contact.title")}
        id="contact"
      />
      <Card>
        <CardContent className="py-8 flex flex-col gap-8">
          <FormInputRow>
            <FormField
              disabled={!isAdmin}
              control={control}
              name="email"
              render={({ field }) => (
                <FormInput
                  label={t("settings.shop.mail")}
                  description={t("settings.shop.mailDescription")}
                  {...field}
                  disabled={disabledBecauseNotAdmin}
                />
              )}
            />

            <FormField
              control={control}
              disabled={!isAdmin}
              name="phone"
              render={({ field: { value, onChange } }) => (
                <FormInput
                  label={t("misc.phone")}
                  description={t("settings.shop.phoneDescription")}
                  value={value}
                  onChange={onChange}
                  placeholder="Téléphone"
                  disabled={disabledBecauseNotAdmin}
                />
              )}
            />
          </FormInputRow>
        </CardContent>
      </Card>
    </>
  );
}
